import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'
import { useVatDeclarationsSettlePeriodModal } from '../../context/vatDeclarationsSettlePeriodModalContext'

export const ModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { closeModal, isProcessing, settleVatDeclarationsPeriod, periodData, isCorrection } =
    useVatDeclarationsSettlePeriodModal()

  const handleCancelButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleSettleButtonClick = useCallback(() => {
    track('xxx - Bookkeeping - VAT - Submit VAT DK', {
      buttonClick: 'Submit manually',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      period_settled: periodData?.periodSettled,
      year: periodData?.year,
      type: isCorrection ? 'correction' : 'normal',
    })
    settleVatDeclarationsPeriod()
  }, [settleVatDeclarationsPeriod, periodData, track, isCorrection])

  return (
    <ButtonsGroup>
      <Button variant="text" onClick={handleCancelButtonClick}>
        {t('cancel')}
      </Button>
      <Button onClick={handleSettleButtonClick} loading={isProcessing}>
        {t('vat_declarations.settlement_modal.footer.submit')}
      </Button>
    </ButtonsGroup>
  )
}
